<app-stepper>
    <app-step [title]="'CHECKOUT_STEP.CUSTOMER_INFO_TITLE' | translate"
              [description]="'CHECKOUT_STEP.CUSTOMER_INFO_DESCRIPTION' | translate"
              [submit]="'CHECKOUT_STEP.TO_SHIPPING' | translate"
              [backLink]="basketLink"
              [backLinkText]="'BASKET.RETURN_TO' | translate"
              (open)="updateAddress()">
        <section class="section">
            <h2>{{ 'SHOPPING_AS.TITLE' | translate }}</h2>
            <p>{{ 'SHOPPING_AS.DESCRIPTION' | translate }}</p>
            <app-shopping-as class="main"
                             [initial]="initialShoppingAs"
                             (type)="checkoutType = $event"></app-shopping-as>
        </section>
        @if(checkoutType !== 'private') {
        <section class="section">
            <h2>{{ 'CVR_EAN_LOOKUP.'+checkoutType+'.TITLE' | uppercase | translate }}</h2>
            <p>{{ 'CVR_EAN_LOOKUP.'+checkoutType+'.DESCRIPTION' | uppercase | translate }}</p>
            <app-cvr-ean-lookup class="main"
                                (address)="setAddress($event)"
                                [checkoutType]="checkoutType ?? initialShoppingAs"
                                (vat)="setVat($event)"></app-cvr-ean-lookup>
        </section>
        }
        <section class="section">
            <h2>{{ 'BILLING_INFO.TITLE' | translate }}</h2>
            <p>{{ 'BILLING_INFO.DESCRIPTION' | translate }}</p>
            <form main
                  (submit)="checkoutType === 'private' ? privateSubmit() : (checkoutType === 'business' ? businessSubmit(): organizationSubmit())"
                  class="main"
                  id="address-form">
                @if(checkoutType === 'private') {
                @for (fieldset of privateAddressForm; track $index) {
                <fieldset>
                    <legend>{{ fieldset.legend | translate }}</legend>

                    @for (input of fieldset.inputs; track $index) {
                    <app-input [options]="input">
                        @if(input?.tag == 'textarea') {
                        <textarea [options]="input"></textarea>
                        } @else if(input?.tag == 'select') {
                        <select [options]="input"></select>
                        } @else {
                        <input [options]="input" />
                        }
                    </app-input>
                    }
                </fieldset>
                }
                } @else if (checkoutType === 'business') {
                @for (fieldset of businessAddressForm; track $index) {
                <fieldset>
                    <legend>{{ fieldset.legend | translate }}</legend>

                    @for (input of fieldset.inputs; track $index) {
                    <app-input [options]="input">
                        @if(input?.tag == 'textarea') {
                        <textarea [options]="input"></textarea>
                        } @else if(input?.tag == 'select') {
                        <select [options]="input"></select>
                        } @else {
                        <input [options]="input" />
                        }
                    </app-input>
                    }
                </fieldset>
                }
                } @else if (checkoutType === 'organization') {
                @for (fieldset of organizationAddressForm; track $index) {
                <fieldset>
                    <legend>{{ fieldset.legend | translate }}</legend>

                    @for (input of fieldset.inputs; track $index) {
                    <app-input [options]="input">
                        @if(input?.tag == 'textarea') {
                        <textarea [options]="input"></textarea>
                        } @else if(input?.tag == 'select') {
                        <select [options]="input"></select>
                        } @else {
                        <input [options]="input" />
                        }
                    </app-input>
                    }
                </fieldset>
                }
                }
            </form>
        </section>
    </app-step>
    <app-step [title]="'CHECKOUT_STEP.SHIPPING_TITLE' | translate"
              [description]="'CHECKOUT_STEP.SHIPPING_DESCRIPTION' | translate"
              [submit]="'CHECKOUT_STEP.TO_PAYMENT' | translate"
              [backLink]="currentLink+'?step=0'"
              [backLinkText]="'CHECKOUT_STEP.CUSTOMER_INFO_RETURN' | translate"
              (open)="updateShippingMethods()">
        <section class="section">
            <h2>{{ 'SHIPPING.TITLE' | translate }}</h2>
            <p>{{ 'SHIPPING.DESCRIPTION' | translate }}</p>
            <form main
                  (submit)="shipmentSubmit()"
                  id="shipment-form">
                @for (fieldset of shippingForm; track $index) {
                @for (input of fieldset.inputs; track $index) {
                <fieldset class="main">
                    <app-input [options]="input">
                        <input [options]="input" />
                        <p>{{ input?.data?.method?.description }}</p>

                        @if(input?.data?.method?.usp != null) {
                        <ul>
                            @for (usp of input?.data?.method?.usp; track $index) {
                            <li><app-svg use="checkmark"></app-svg><span>{{usp}}</span></li>
                            }
                        </ul>
                        }
                        <span [attr.post]="shippingTranslateKey | translate">{{ input?.data?.method?.price?.salesPrice | price }}</span>
                    </app-input>
                </fieldset>
                } @empty {
                <p class="main"
                   empty>{{ 'SHIPPING.NO_VALID_METHODS' | translate }}</p>
                }
                } @empty {
                <p class="main"
                   empty>{{ 'SHIPPING.NO_VALID_METHODS' | translate }}</p>
                }

            </form>
        </section>
    </app-step>
    <app-step [title]="'CHECKOUT_STEP.PAYMENT_TITLE' | translate"
              [description]="'CHECKOUT_STEP.PAYMENT_DESCRIPTION' | translate"
              [submit]="'CHECKOUT_STEP.TO_INVOICE' | translate"
              [backLink]="currentLink+'?step=1'"
              [backLinkText]="'CHECKOUT_STEP.SHIPPING_RETURN' | translate"
              (open)="updatePaymentForm()">
        <section class="section">
            <h2>{{ 'PAYMENT.TITLE' | translate }}</h2>
            <p>{{ 'PAYMENT.DESCRIPTION' | translate }}</p>
            <form main
                  novalidate
                  (submit)="paymentSubmit()"
                  id="payment-form">

                @for (fieldset of paymentForm; track $index) {
                @for (input of fieldset.inputs; track $index) {
                <fieldset class="main">
                    <app-input [options]="input">
                        <input [options]="input"
                               [attr.label]="input?.label"
                               [attr.price]="input?.data?.price?.amount"
                               [attr.vat]="input?.data?.vat?.amount" />
                        @if((input?.data?.icons?.length??0) > 0) {
                        <div class="icons"
                             [attr.aria-label]="'PAYMENT_CARD.LABEL'|translate">
                            @for (icon of input?.data?.icons; track $index) {
                            <img [src]="icon?.imageUrl"
                                 [alt]="icon?.alt"
                                 height="20">
                            }
                        </div>
                        }
                        <p class="description">{{ input?.data?.description }}</p>
                        @if(input?.data?.price?.amount > 0) {
                        <p class="price">{{ input?.data?.price | price }} {{ 'PAYMENT.TRANSACTION_FEE_EXCLUDING_VAT' | translate }}</p>
                        }
                        @if(input?.data?.options?.length > 0) {
                        <div class="invoice-options">
                            @for (option of input?.data?.options; track $index) {
                            <app-input [options]="option">
                                <input [options]="option" />
                            </app-input>
                            }
                        </div>
                        }
                        <span [attr.post]="paymentTranslateKey | translate">{{ input?.data?.method?.price?.salesPrice | price }}</span>
                    </app-input>
                </fieldset>
                } @empty {
                <p class="main"
                   empty>{{ 'PAYMENT.NO_VALID_METHODS' | translate }}</p>
                }
                } @empty {
                <p class="main"
                   empty>{{ 'PAYMENT.NO_VALID_METHODS' | translate }}</p>
                }
                <hr>
                <div class="main checkbox">
                    @if(termsInput$ | async; as termsInput) {
                    <app-input [options]="termsInput">
                        <input [options]="termsInput" />
                        <button class="terms-button"
                                type="button"
                                label
                                (click)="openTerms()">{{ 'CHECKOUT.TERMS_LINK' | translate }}</button>
                    </app-input>
                    <dialog [modal]="true"
                            id="terms-modal">
                        <button closeDialog></button>
                        <div>
                            <layout-block-list-outlet [list]="termsLayout"></layout-block-list-outlet>
                        </div>
                    </dialog>
                    }
                    @if(newsInput$ | async; as newsInput) {
                    <app-input [options]="newsInput">
                        <input [options]="newsInput" />
                    </app-input>
                    }
                </div>
            </form>
        </section>
    </app-step>
    <app-step [title]="'CHECKOUT_STEP.INVOICE_TITLE' | translate"
              [description]="'CHECKOUT_STEP.INVOICE_DESCRIPTION' | translate"
              [submit]="'CHECKOUT_STEP.TO_' | translate"
              [backLink]="currentLink+'?step=2'"
              [backLinkText]="'CHECKOUT_STEP.PAYMENT_RETURN' | translate">
    </app-step>
</app-stepper>
<footer>
    <app-usp-bulk-element [layout]="checkout?.usp||[]"></app-usp-bulk-element>
</footer>
